import { KnmWebNotificationTypesEnum } from 'APIPackage/KnmModule/enums/KnmWebNotificationTypesEnum';

export const mapWebNotificationInfoByTitle: Record<KnmWebNotificationTypesEnum, string> = {
  [KnmWebNotificationTypesEnum.VP]:
    'Отправка уведомления в АИК "Надзор-Web" о регистрации внепланового КНМ, требующего согласования',
  [KnmWebNotificationTypesEnum.AGREEMENT]:
    'Отправка уведомления в АИК "Надзор-Web" о составлении соглашения об устранении нарушения',
  [KnmWebNotificationTypesEnum.VP_AGREEMENT_4_1_37]:
    'Отправка уведомления в АИК "Надзор-Web" о регистрации внепланового КНМ, требующего согласования',
  [KnmWebNotificationTypesEnum.VP_AGREEMENT]:
    'Отправка уведомления в АИК "Надзор-Web" о решении прокурора по согласованию внепланового мероприятия в системе ЕРКНМ (согласовано/отказано)',
  [KnmWebNotificationTypesEnum.PLAN_GENERAL]:
    'Отправка уведомления в АИК "Надзор-Web" о необходимости согласования плана',
  [KnmWebNotificationTypesEnum.PLAN_GENERAL_AGREEMENT]:
    'Отправка уведомления в АИК "Надзор-Web" о результатах согласования плана прокурором в системе ЕРКНМ',
  [KnmWebNotificationTypesEnum.PLAN_GENERAL_CHANGE]:
    'Отправка уведомления о внесении изменений в согласованный план (удаление/изменение)',
  [KnmWebNotificationTypesEnum.PLAN_GENERAL_ADD]:
    'Отправка уведомления о внесении изменений в согласованный план (добавление проверки)',
  [KnmWebNotificationTypesEnum.PLAN_GENERAL_ADD_AGREEMENT]:
    'Отправка уведомления по результатам согласования планового КНМ, добавленного в утвержденный план (согласовано/отказано)',
  [KnmWebNotificationTypesEnum.APPEAL]:
    'Уведомление об обжаловании контрольным (надзорным) органом решения прокурора о согласовании',
};
